// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-primary-button {
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-shadow: 0 5px 10px 5px rgba(0, 0, 0, 0.50);
  background-color: transparent;
  padding: 22px 32px;
  font-size: 20px;
  font-weight: 700;
  transition: color 0.36s, background-color 0.36s;
  display: none;
}

.left-primary-button:hover {
  color: white;
  background-color: transparent;
}

.left-primary-button.white-color-button {
  background-color: var(--white);
  color: var(--pabloo-green);
  border-radius: 8px;
  padding: 18px 22px;
  display: block;
}

.left-primary-button.white-color-button:hover {
  border-color: var(--white);
  color: var(--white);
  background-color: transparent;
}

.left-primary-button.contact-button {
  margin-top: 48px;
}

.left-primary-button.contact-button.show {
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 18px;
}

.left-primary-button.home {
  float: none;
  clear: none;
  border-radius: 8px;
  flex: none;
  padding: 12px 16px;
  font-size: 18px;
  display: flex;
  position: static;
}

.left-primary-button.home.pricing-cta {
  float: left;
}

.left-primary-button.white-alter-button {
  border-color: var(--white);
  background-color: var(--pabloo-green);
}

.left-primary-button.white-alter-button:hover {
  background-color: var(--black);
  color: var(--white);
}

.left-primary-button.popup-form-button {
  margin-top: 36px;
}

.left-primary-button.visible,
.left-primary-button.show {
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 18px;
  display: block;
}

.left-primary-button.white-button.book-button {
  border-style: solid;
  border-color: var(--white);
  color: #d53987;
  text-align: center;
  border-radius: 6px;
  padding: 12px 20px;
  font-size: 16px;
  line-height: 140%;
  display: block;
}

.left-primary-button.white-button.book-button:hover {
  border-style: solid;
  border-color: var(--white);
  background-color: var(--black);
  color: var(--white);
  transform: none;
}

.left-primary-button.white-button.book-button.banner-cta-new {
  width: 200px;
}

.left-primary-button.white-button.ads-button {
  color: var(--pabloo-green);
  border-radius: 6px;
  width: auto;
  max-width: none;
  padding: 12px 20px;
  font-size: 20px;
  line-height: 140%;
  display: inline-block;
}

.left-primary-button.white-button.ads-button:hover {
  border-color: var(--white);
  color: var(--white);
  background-color: transparent;
}

@media screen and (min-width: 1440px) {
  left-primary-button.white-button.book-button {
    font-size: 16px;
  }
  left-primary-button.white-button.book-button {
    font-size: 20px;
  }
}

@media screen and (max-width: 991px) {
  .left-primary-button {
    padding: 20px;
  }

  left-primary-button.popup-form-button {
    padding-top: 16px;
    padding-bottom: 16px;
  }
}

@media screen and (max-width: 767px) {
  .left-primary-button {
    font-size: 16px;
  }

  left-primary-button.white-alter-button {
    text-align: center;
    width: 100%;
  }

  left-primary-button.popup-form-button {
    width: 100%;
  }
}

@media screen and (max-width: 479px) {
  .left-primary-button {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/contact/leftButtonStyling.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".left-primary-button {\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  box-shadow: 0 5px 10px 5px rgba(0, 0, 0, 0.50);\n  background-color: transparent;\n  padding: 22px 32px;\n  font-size: 20px;\n  font-weight: 700;\n  transition: color 0.36s, background-color 0.36s;\n  display: none;\n}\n\n.left-primary-button:hover {\n  color: white;\n  background-color: transparent;\n}\n\n.left-primary-button.white-color-button {\n  background-color: var(--white);\n  color: var(--pabloo-green);\n  border-radius: 8px;\n  padding: 18px 22px;\n  display: block;\n}\n\n.left-primary-button.white-color-button:hover {\n  border-color: var(--white);\n  color: var(--white);\n  background-color: transparent;\n}\n\n.left-primary-button.contact-button {\n  margin-top: 48px;\n}\n\n.left-primary-button.contact-button.show {\n  border-radius: 8px;\n  padding: 12px 24px;\n  font-size: 18px;\n}\n\n.left-primary-button.home {\n  float: none;\n  clear: none;\n  border-radius: 8px;\n  flex: none;\n  padding: 12px 16px;\n  font-size: 18px;\n  display: flex;\n  position: static;\n}\n\n.left-primary-button.home.pricing-cta {\n  float: left;\n}\n\n.left-primary-button.white-alter-button {\n  border-color: var(--white);\n  background-color: var(--pabloo-green);\n}\n\n.left-primary-button.white-alter-button:hover {\n  background-color: var(--black);\n  color: var(--white);\n}\n\n.left-primary-button.popup-form-button {\n  margin-top: 36px;\n}\n\n.left-primary-button.visible,\n.left-primary-button.show {\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 18px;\n  display: block;\n}\n\n.left-primary-button.white-button.book-button {\n  border-style: solid;\n  border-color: var(--white);\n  color: #d53987;\n  text-align: center;\n  border-radius: 6px;\n  padding: 12px 20px;\n  font-size: 16px;\n  line-height: 140%;\n  display: block;\n}\n\n.left-primary-button.white-button.book-button:hover {\n  border-style: solid;\n  border-color: var(--white);\n  background-color: var(--black);\n  color: var(--white);\n  transform: none;\n}\n\n.left-primary-button.white-button.book-button.banner-cta-new {\n  width: 200px;\n}\n\n.left-primary-button.white-button.ads-button {\n  color: var(--pabloo-green);\n  border-radius: 6px;\n  width: auto;\n  max-width: none;\n  padding: 12px 20px;\n  font-size: 20px;\n  line-height: 140%;\n  display: inline-block;\n}\n\n.left-primary-button.white-button.ads-button:hover {\n  border-color: var(--white);\n  color: var(--white);\n  background-color: transparent;\n}\n\n@media screen and (min-width: 1440px) {\n  left-primary-button.white-button.book-button {\n    font-size: 16px;\n  }\n  left-primary-button.white-button.book-button {\n    font-size: 20px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .left-primary-button {\n    padding: 20px;\n  }\n\n  left-primary-button.popup-form-button {\n    padding-top: 16px;\n    padding-bottom: 16px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .left-primary-button {\n    font-size: 16px;\n  }\n\n  left-primary-button.white-alter-button {\n    text-align: center;\n    width: 100%;\n  }\n\n  left-primary-button.popup-form-button {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  .left-primary-button {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
